var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 86,
    viewBox: "0 0 203 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.691,
    cy: -177.899,
    r: 263.16,
    fill: "#0E4E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfbg);
export default __webpack_public_path__ + "static/media/pdfbg.534434d4e50942f49bacefe9d2853d55.svg";
export { ForwardRef as ReactComponent };